import { Button } from '@teach/ui'
import type { EmptyVideoGateState } from './EmptyVideoGate'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  gate: EmptyVideoGateState
}

/**
 * Сбой проверки видео-блоков (п.19) над `AccessSection`. Пустые блоки
 * постоянной плашкой больше не показываются — отказ объясняет уведомление в
 * момент попытки опубликовать (`emptyVideoRefusal`). Важно (ревью
 * Task 3): раньше сетевая ошибка молча зависала в `isLoading: true` навсегда
 * — правда про отказ и «Повторить» тут ОБЯЗАТЕЛЬНЫ, иначе честная
 * публикация упирается в разовый сетевой сбой без единого объяснения и без
 * выхода, кроме переоткрытия диалога.
 */
export const EmptyVideoStatus = ({ gate }: Props) => {
  const m = useMessages(messages)
  return gate.isError ? (
    <div className="flex items-center justify-between gap-3 rounded-2xl border border-warning/30 bg-warning/10 p-4 text-sm text-warning">
      <p>{m.videoCheckFailed}</p>
      <Button variant="outline" size="sm" onClick={gate.retry}>
        {m.retry}
      </Button>
    </div>
  ) : null
}
